<template>
  <div></div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  name: 'DeleteConfirmation',
  methods: {
    showModal(name) {
      Swal.fire({
        title: 'Xóa tài khoản!',
        text: `Bạn có chắc muốn xóa tài khoản ${name} này không ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit('confirm');
        }
      });
    },
  },
};
</script> 
